import { useCallback, useEffect, useState } from 'react'
import { DictVoucherTPVTy } from '../../../../app/erp/screens/TPV/TPVDashboard/types'
import { twinFetchPostJSON } from '../../../globals/data'
import { getCurrencySymbol } from '../../../globals/price'

interface GetDictPaymentBanksProps {
    SellTicketId: number
    CustomerId?: number
}

const useGetSellticketCustomerVouchers = ({ CustomerId, SellTicketId }: GetDictPaymentBanksProps) => {
    const [dictVouchers, setDictVouchers] = useState<DictVoucherTPVTy>(null)

    const createVoucherInfo = useCallback((result: any) => {
        const myResult: DictVoucherTPVTy = {}
        for (const element of result) {
            const currency = getCurrencySymbol(element.subType)
            myResult[element.id] = { ...element, label: element.voucher_n + ' (' + element.amount + currency +')'}
        }
        return myResult
    }, [])

    const getCustomerVouchers = useCallback(async () => {
        if (CustomerId) {
            const result = await twinFetchPostJSON('/api/app/order/tpv/sellTicket/getSellTicketCustomerVouchers', { CustomerId, SellTicketId })
            if (result) {
                const myResult = createVoucherInfo(result)
                setDictVouchers(myResult)
            }
        }
    }, [setDictVouchers, CustomerId, SellTicketId, createVoucherInfo])

    useEffect(() => {
        getCustomerVouchers()
    }, [getCustomerVouchers])

    return { dictVouchers }
}

export default useGetSellticketCustomerVouchers